import SolutionsCalloutText from '../blocks/SolutionsCalloutText'
import ImageButtonWithLabel from './image-button-with-label'
import IndexText from './index-text'
import Button from './ui/button'
import Text from './ui/text'
import Image from 'next/image'
import Link from 'next/link'
import React, { ReactElement } from 'react'
import { IoMdReturnRight } from 'react-icons/io'

interface Props {
  index: number
  slug?: string
  title: string
  description: string
  imageUrl: string
  href?: string | null
}

function SolutionListItem({
  index,
  slug,
  href = null,
  title,
  description,
  imageUrl,
}: Props): ReactElement {
  return (
    <>
      {index === 0 ? (
        <SolutionsCalloutText text="Give your business a march on nefarious actors." />
      ) : index === 1 ? (
        <SolutionsCalloutText text="Delivering critical infrastructure protection and smarter data intelligence." />
      ) : (
        <div className="col-span-4 hidden lg:block" />
      )}

      <div className="group col-span-4 bg-black">
        <div className="relative min-h-[280px] xl:min-h-[300px]">
          <div className="from-telesoft absolute inset-0 z-10 bg-gradient-to-tr to-transparent mix-blend-soft-light" />
          <div className="bg-gradient-t-r from-telesoft absolute inset-0 z-10 to-transparent mix-blend-soft-light" />
          <Image
            fill
            alt="Not found"
            src={imageUrl}
            className="overflow-hidden object-cover object-center transition-transform duration-1000 group-hover:scale-105"
          />
          <ImageButtonWithLabel
            label={'View'}
            link={slug ? `/solutions/${slug}` : href ? href : '#!'}
            hideLabel={true}
            variant="right"
          />

          <div className="lg:group-hover:bg-accent-1 absolute inset-0 left-0 right-0 z-20 flex flex-col border-b border-black bg-black bg-opacity-50 p-10 text-white transition-colors duration-300 lg:top-[280px] lg:min-h-[312px] lg:bg-transparent xl:top-[300px] xl:min-h-[332px] xl:text-black">
            <IndexText index={index} />
            <div className="flex max-w-lg items-start justify-start">
              <IoMdReturnRight className="mr-2 mt-3 text-xl text-white lg:text-black lg:group-hover:text-black xl:mt-[18px]" />
              <Text
                variant="mediumHeading"
                className="mr-2 mt-2 text-white lg:text-black lg:group-hover:text-black"
              >
                {title}
              </Text>
            </div>

            <div className="mt-0 flex flex-col items-start justify-start text-white md:mt-1 lg:text-black lg:group-hover:text-black xl:mt-2">
              <Text className="max-w-xs">{description}</Text>

              <Link passHref href={slug ? `/solutions/${slug}` : href ? href : '#!'} legacyBehavior>
                <Button
                  className="mt-2 text-white md:mt-4 lg:text-black lg:group-hover:text-black xl:mt-6"
                  invert={true}
                  variant="cta"
                >
                  Learn More
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SolutionListItem
